import AnnouncementsForm from './AnnouncementsForm';

export default AnnouncementsForm;
